import { ReactComponent as LogoFull } from 'assets/brand/LogoFull.svg';
import styles from './MainLayout.module.css';
import { PropsWithChildren } from 'react';
import ErrorBoundary from 'utility/ErrorBoundary';
import { FormError } from 'modules/PaymentRequest/FormIssues/FormIssues';

const MainLayout = ({ children }: PropsWithChildren) => {
    const currentYear = new Date().getFullYear();
    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <header>
                    <div>
                        <LogoFull className={styles.logo} />
                    </div>
                </header>
                <main>
                    <ErrorBoundary fallbackRender={() => <FormError />}>{children}</ErrorBoundary>
                </main>
                <footer className={styles.footer}>
                    <span>© {currentYear} micro.wav</span>
                    <a href="mailto:info@micro-wav.com">Questions? Get in touch</a>
                </footer>
            </div>
        </div>
    );
};

export default MainLayout;
